import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/domains/landing-page/components/Header';
import HeroSection from '@/domains/landing-page/components/HeroSection';
import WorkflowSection from '@/domains/landing-page/components/WorkflowSection';
import FeaturesSection from '@/domains/landing-page/components/FeaturesSection';
import RegisterSection from '@/domains/landing-page/components/RegisterSection';
import KeyFeaturesSection from '@/domains/landing-page/components/KeyFeaturesSection';
import FooterSection from '@/domains/landing-page/components/FooterSection';
import LanguageModal from '@/domains/landing-page/components/LanguageModal';
import MobileMoneyModal from '@/domains/landing-page/components/MobileMoneyModal';
import { LandingDataProvider } from '@/domains/landing-page/context/LandingDataContext';

function HomePageContent() {
  const navigate = useNavigate();
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [showMobileMoney, setShowMobileMoney] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('fr');
  const [isOfflineMode] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header
        isOfflineMode={isOfflineMode}
        setShowLanguageModal={setShowLanguageModal}
        setShowCommunityDelivery={() => setShowMobileMoney(true)}
        setShowRealTimeTracking={() => navigate('/tracking')}
      />

      <HeroSection />
      <WorkflowSection />
      <FeaturesSection />
      <RegisterSection />
      <KeyFeaturesSection
        setShowCommunityDelivery={() => setShowMobileMoney(true)}
        setShowRealTimeTracking={() => navigate('/tracking')}
      />
      <FooterSection />

      <LanguageModal
        showLanguageModal={showLanguageModal}
        setShowLanguageModal={setShowLanguageModal}
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
      />
      <MobileMoneyModal
        showMobileMoney={showMobileMoney}
        setShowMobileMoney={setShowMobileMoney}
      />
    </div>
  );
}

export default function HomePage() {
  return (
    <LandingDataProvider>
      <HomePageContent />
    </LandingDataProvider>
  );
}
